export const TRIAL_EXPIRED = 'TRIAL_EXPIRED'

export const trialExpired = () => ({
  type: TRIAL_EXPIRED
})
